import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class UsageHistoryHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
        loading: false,
        isOpen: false,
    };
  }

  componentDidMount() {

  }

  openModal = (section) => {
    this.setState({
      isOpen: true,
    });
  };
  closeModal = () => {
    this.setState({ isOpen: false });
  };

  //Arrow function for renderLoader

  render() {

    return (
        <div className="panel-header">
          <div className="pull-left h-100 vertical-align-center">
            <div>
              <div className="custom-text1-primary-medium">
                {LocaleStrings.accountsetting_usagehistory_headertitle}
              </div>
              <div className="custom-text2-secondary-normal">
                {LocaleStrings.accountsetting_usagehistory_headerdesc}   <span style={{color:'#105efb'}}>{this.props.user.email}</span>
              </div>
            </div>
          </div>
          <div className="pull-right h-100 vertical-align-center">
     
          </div>
        </div>
    );
  }
}


function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {})(UsageHistoryHeader);
